import React from 'react'
import { ImageLoader } from '@usap/uicomponents'
import SetKitDisplay from '../../../../../SetKitDisplay'
import { setQtyRange } from '../../../../Forms/RMAReturnItemInfo/utils'
import { Heading4, OrderDateDetails, ItemDetailWrapper, BrandName, ItemDetail, QuantitySelectionWrapper, ImageContainer } from '../../style/LifetimeReplacementWmo.css'
import QuantitySelectionWMO from '../../../../Forms/RMAReturnItemInfo/component/ItemDetail/QuantitySelectionWMO'

const ItemDetailWmo = ({ item, handleQtyChange, imageText, orderDetails }) => {
  const {
    brandText,
    partNumber,
    parentSku,
    skuTitle,
    imageSrc,
    qtyRange,
    itemPriceParsed,
    qtyToCompute,
    eligibleRMA,
  } = { ...item }
  const {
    merchant_order_id: orderNumber,
    order_date: orderDate,
  } = { ...orderDetails }

  return (
      <>
        <Heading4>Your Original Order</Heading4>
        <OrderDateDetails>
            <div className="detailWrapper">
                <span className="key"> Order #:&nbsp;</span>
                <span className="value"> {orderNumber}</span>
                <span className='separator'> | </span>
            </div>
            <div className="detailWrapper">
                <span className="key"> Date Purchased:&nbsp;</span>
                <span className="value"> {orderDate}</span>
                <span className='separator'> | </span>
            </div>
            <div className="detailWrapper">
                <span className="key"> Part Number :&nbsp;</span>
                <span className="value"> {partNumber}</span>
            </div> 
        </OrderDateDetails>
        <ItemDetailWrapper>
            <ImageContainer>
                <ImageLoader
                key={Math.random()}
                width="100%"
                height="100%"
                src={imageSrc}
                fit="contain"
                alt={imageText}
                cloudinaryParams="h_125,w_125"
                fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
                />
            </ImageContainer>
            <ItemDetail>
                <div>
                    <BrandName>{brandText}</BrandName>®&nbsp;
                    <span>{skuTitle}</span>
                </div>
                <QuantitySelectionWrapper>
                    <QuantitySelectionWMO
                        eligibleRMA={eligibleRMA}
                        partNumber={partNumber}
                        setQtyRange={setQtyRange}
                        handleQtyChange={handleQtyChange}
                        ikey={0}
                        qtyRange={qtyRange}
                        qtyToCompute={qtyToCompute}
                    />
                </QuantitySelectionWrapper>
                <div className="unitPrice">
                    Unit Price: $
                    {parseFloat(itemPriceParsed).toFixed(2)}
                </div>
                {
                    parentSku && (
                    <SetKitDisplay
                        parentSku={parentSku}
                        showPartNumber={false}
                        isWmoEnabled
                    />
                    )
                }
            </ItemDetail>
        </ItemDetailWrapper>
      </>
  )
}

export default ItemDetailWmo
